<div class="content-wrapper">
  <div class="content my-auto">
  <div class="grid-cont">
    <div class="login register">
      <aiwyn-logo [height]="60" [extraClasses]="'mb-6 login__logo'"></aiwyn-logo>

      <div class="block login__cont">
        <h2>Create an Account</h2>

        <form name="registerForm" [formGroup]="registerForm" novalidate class="mt--200">
          <div class="mt--075 form-control">
            <input type="email" name="email" placeholder="Email *" class="form-input" formControlName="email" data-cy="email" #email>
            <div class="form-control__post-icon">
              <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </div>
          </div>

          <div class="mt--075 form-control">
            <input type="text" name="name" placeholder="First & last name *" class="form-input"
                   formControlName="name" data-cy="name" #name>
            <div class="form-control__post-icon">
              <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"
                   stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
          </div>

          <div class="mt--075 form-control">
            <input type="password" name="password" placeholder="Password *" class="form-input"
                   formControlName="password" data-cy="password">
            <div class="form-control__post-icon">
              <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"
                   stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </div>
          </div>

          <div class="mt--075 form-control">
            <input
              type="password"
              name="passwordConfirm"
              placeholder="Confirm password *"
              class="form-input"
              formControlName="passwordConfirm"
              data-cy="confirm-password"
            >
            <div class="form-control__post-icon">
              <svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none"
                   stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </div>
          </div>

          <mat-checkbox formControlName="terms" class="mt-4" data-cy="terms-and-conditions">
            <p class="group-500">
              Agree to Aiwyn's
              <a class="inline-link" data-cy="terms-and-conditions-link" (click)="legalService.openTermsAndConditions()">
                Terms of Service
              </a>
              and
              <a class="inline-link" data-cy="privacy-policy-link" (click)="legalService.openPrivacyPolicy()">Privacy Policy</a>
            </p>
          </mat-checkbox>

          <button
            andButton
            size="large"
            color="primary"
            [disabled]="registerForm.invalid"
            [isLoading]="isRegistrationLoading$ | async"
            id="createAccountButton"
            class="mt--200 button--wide"
            (click)="createAccount()"
            data-cy="register-account"
          >
            Create an Account
          </button>
          <div style="padding-top: 20px">
            <mat-error
              *ngIf="registerForm['controls'].email.invalid === true && registerForm['controls'].email.pristine === false"
              class="tc--error">
              Email is not valid.
            </mat-error>

            @if (registerForm.get('password')?.errors && !registerForm.get('password')?.pristine) {
              @if (registerForm.get('password')?.errors?.required) {
                <mat-error id="required-password-error" class="tc--error">Password is required.</mat-error>
              }
              @if (registerForm.get('password')?.errors?.minlength) {
                <mat-error id="min-length-password-error" class="tc--error">Password must be at least 12 characters.</mat-error>
              }
              @if (registerForm.get('password')?.errors?.maxlength) {
                <mat-error id="max-length-password-error" class="tc--error">Password cannot exceed 60 characters.</mat-error>
              }
              @if (registerForm.get('password')?.errors?.whitespace) {
                <mat-error id="whitespace-password-error" class="tc--error">Password cannot begin or end with spaces.</mat-error>
              }
              @if (registerForm.get('password')?.errors?.uppercase) {
                <mat-error id="uppercase-password-error" class="tc--error">Please include at least one uppercase letter (A-Z).</mat-error>
              }
              @if (registerForm.get('password')?.errors?.lowercase) {
                <mat-error id="lowercase-password-error" class="tc--error">Please include at least one lowercase letter (a-z).</mat-error>
              }
              @if (registerForm.get('password')?.errors?.numbers) {
                <mat-error id="number-password-error" class="tc--error">Please include at least one number (0-9).</mat-error>
              }
              @if (registerForm.get('password')?.errors?.symbol) {
                <mat-error id="symbol-password-error" class="tc--error">Please include at least one special character {{ specialCharacters }}.</mat-error>
              }
            }

            <div *ngIf="registerForm['controls'].passwordConfirm.pristine === false">
              <mat-error *ngIf="registerForm.get('passwordConfirm')?.errors?.passwordsNotMatching" class="tc--error">
                Passwords don't match.
              </mat-error>
            </div>
          </div>
          <div class="mt--150 login__hr"><span>OR</span></div>

          <button
            andButton
            size="large"
            color="secondary"
            id="loginButton"
            class="mt--200 w-100"
            data-cy="login"
            (click)="navigateToLogin()"
          >
            {{ loginButtonText }}
          </button>

        </form>
      </div>
    </div>
  </div>

    <app-full-client-portal-footer class="mt-6 px-6 pb-6"></app-full-client-portal-footer>
</div>
</div>
